import { toast } from 'lib';
import translation from 'translation';

export const validateImage = (file, type) => {
  const { t } = translation;

  const allowedTypes = ['image/jpeg', 'image/png'];
  const limits = {
    profile: 500, // 500 KB
    bulletin: 1024, // 1 MB = 1024 KB
  };

  const maxFileSizeKb = limits[type];
  const fileSizeKB = file.size / 1024;

  if (!allowedTypes.includes(file.type)) {
    toast({
      title: t('common:error'),
      description: t('common:fileFormatError'),
      type: 'error',
    });
    return null;
  }

  if (fileSizeKB > maxFileSizeKb) {
    const sizeText = type === 'profile' ? '500KB' : '1MB';
    toast({
      title: t('common:error'),
      description: t('common:fileSizeError', { size: sizeText }),
      type: 'error',
    });
    return null;
  }

  return file;
};
